/**
 * رابط السيرفر (Base URL) للـ API وكل الصور.
 *
 * ازاي تغيّره لما تنقل المشروع للعميل:
 * 1. افتح ملف .env في جذر المشروع (أو أنشئه لو مش موجود، على نفس مستوى package.json).
 * 2. حط فيه السطر ده برابط سيرفر العميل:
 *      REACT_APP_API_BASE_URL=https://client-domain.com/
 * 3. اعمل بيلد تاني للمشروع (npm run build) عشان القيمة الجديدة تتضمن في البيلد.
 *
 * لو REACT_APP_API_BASE_URL مش متظبطة، هيرجع تلقائي لرابط سيرفر الإنتاج
 * الحقيقي بتاع Meat House عشان الموقع الحي ميفضلش يكلم سيرفر التيست بالغلط.
 */
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://erp.meat-house.online/";

/**
 * رابط الصورة الافتراضية (Placeholder) المستخدمة في كل الأماكن اللي مفيهاش صورة منتج/تصنيف.
 * بيتبني تلقائياً على نفس API_BASE_URL، فمش محتاج تعدله بشكل منفصل.
 */
export const DEFAULT_IMAGE_URL = `${API_BASE_URL}img/default.png`;
